export default __webpack_public_path__ + "static/media/mooncake-progress-1-4.fe2acb12.svg";